// extracted by mini-css-extract-plugin
var _1 = "EpostStatusTimelineTrackingId-moduletext__zVsHl";
export { _1 as "text" }
